/// <amd-module name="Test/TestPlansHubRefresh/TestPlansSegment/Redux/TestPlansSegmentModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { TestPlansSegmentReducer } from "./TestPlansSegmentReducer";
import { TestPlansSegmentSaga } from "./TestPlansSegmentSaga";
import { TestHubRefreshReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshReducer";
import { ITestPlansSegmentAwareState } from "./TestPlansSegmentContracts";

export const TestPlansSegmentModule: ISagaModule<ITestPlansSegmentAwareState> = {
    id: "testplans-segment",
    reducerMap: {
        testPlansSegmentState: TestPlansSegmentReducer,
        testHubRefreshState: TestHubRefreshReducer
    },
    sagas: [TestPlansSegmentSaga]
};
